module.exports = __webpack_public_path__ + "static/media/marketWatch.65d77844.png";